<template>
    <div :class="{ 'admin-link': true, 'tasks': true, 'none': count <= 0}">
        <a href="/task-manager" :title="count + (count == 1 ? ' task, ' : ' tasks, ') + unassigned + ' unassigned'">
            <icon type="solid" name="faTasks" aria-hidden="true" focusable="false" class="nav-icon"></icon>
            <span v-if="count > 0" class="td-circle-badge">{{ count }}</span>
        </a>
    </div>

</template>

<script>import script from './AdminTasksLink';
    export default script;</script>

<style lang="less">
    @import "./AdminTasksLink.less";
</style>
